import { inject, Injectable } from '@angular/core';

import { Store } from '@ngxs/store';

import { Observable } from 'rxjs';

import { CognitoState } from '../store/cognito.state';

@Injectable()
export class CognitoSelector {
  //@Select(CognitoState.getIsAuthenticated) isAuthenticated$: Observable<boolean>;
  isAuthenticated$: Observable<boolean> = inject(Store).select(CognitoState.getIsAuthenticated);
  idToken$: Observable<string> = inject(Store).select(CognitoState.getIdToken);
  accessToken$: Observable<string> = inject(Store).select(CognitoState.getAccesToken);
}
